function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{opacity:0.4295;enable-background:new    ;}\n\t.st1{opacity:0.1255;fill:#0D6D9E;enable-background:new    ;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{fill:#D6DCE4;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "st0"
}, /*#__PURE__*/React.createElement("rect", {
  className: "st1",
  width: 567.1,
  height: 302.6
}));

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 283.5,
  cy: 151.3,
  r: 100
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M327.5,116.4l-27.1-27.1c-0.8-1.2-2.1-1.6-3.3-1.6h-45.2c-7.4,0-13.6,6.2-13.6,13.6v100.3 c0,7.4,6.2,13.6,13.6,13.6h63.3c7.4,0,13.6-6.2,13.6-13.6v-81.8C328.7,118.4,328.3,117.2,327.5,116.4z M319.7,201.5 c0,2.5-2.1,4.5-4.5,4.5h-63.3c-2.5,0-4.5-2.1-4.5-4.5V101.1c0-2.5,2.1-4.5,4.5-4.5h40.7v13.6c0,7.4,6.2,13.6,13.6,13.6h13.6 C319.7,123.8,319.7,201.5,319.7,201.5z"
});

function SvgDocAssetTypeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 567.1 302.6",
    style: {
      enableBackground: "new 0 0 567.1 302.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocAssetTypeIcon);
export default __webpack_public_path__ + "static/media/doc-asset-type-icon.30fc2286.svg";
export { ForwardRef as ReactComponent };